import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { hideRecommendationsTooltip } from '../../actions/common';
import { switchToOldInterface as switchToOldInterfaceAction } from '../../actions/grid-screen';
import { fetchHeaderInfo, fetchUserAccountsInfo, fireCommonWalletClick, sendGridFeedback } from '../../actions/header';
import { Header, HeaderProps } from '../../components/Header/Header';
import { RoutesPath } from '../../routes/index';
import {
    selectAdditionalUserInfo,
    selectHeaderActionsMenu,
    selectHeaderTabLinks,
    selectHeaderWallet,
    selectInfoLinks
} from '../../selectors/header/header';
import { HeaderHelpers } from '../../service/HeaderHelpers/HeaderHelpers';
import { LangUtils } from '../../service/Lang/Lang';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

interface OwnProps {
    enableSidebar: boolean;
}

export type DispatchProps = TDispatchProps<HeaderProps>;

export type StateProps = TStateProps<HeaderProps, OwnProps>;

export const mapStateToProps = (state: State): StateProps => {
    const {
        commonData: { tld, authorizationData, constants },
        devInfo,
        router: { route },
        header: {
            infoBlockData: { isInfoBlockAvailable },
            isB2bBalanceCartEnabled
        }
    } = state;

    const currentLang = LangUtils.getCurrentLang();
    const tabLinks = selectHeaderTabLinks(state);
    const infoLinks = selectInfoLinks(state);
    const wallet = selectHeaderWallet(state);
    const additionalUserInfo = selectAdditionalUserInfo(state);
    const needWallet = Boolean(authorizationData);
    const balanceDomain = constants && constants.balanceDomain;

    return {
        devInfo,
        isBeta: false,
        currentLang: currentLang,
        tld,
        hasServicesMenu: true,
        isFeedbackPromoNeedToShow: HeaderHelpers.isFeedbackPromoNeedToShow(),
        infoLinks,
        tabLinks,
        wallet,
        isInfoBlockAvailable,
        isFeedbackVisible:
            route === RoutesPath.grid ||
            route === RoutesPath.shortGrid ||
            route === RoutesPath.campaignsEdit ||
            route === RoutesPath.bannersEdit ||
            route === RoutesPath.groupsEdit,
        isSwitchToOldInterfaceLinkVisible: !(
            (route === RoutesPath.bannersEdit || route === RoutesPath.groupsEdit) &&
            state.commonData.fromOldInterface
        ),
        needWallet,
        actionsMenu: selectHeaderActionsMenu(state),
        additionalUserInfo,
        isB2bBalanceCartEnabled: Boolean(isB2bBalanceCartEnabled),
        balanceCartHost: balanceDomain
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        fetchUserAccountsInfo: () => {
            dispatch(fetchUserAccountsInfo());
        },
        sendGridFeedback: (message: string) => {
            dispatch(sendGridFeedback(message));
        },
        initFeedbackPromo: () => {
            HeaderHelpers.initFeedbackPromo();
        },
        fetchHeaderInfoData: () => {
            dispatch(fetchHeaderInfo());
        },
        switchToOldInterface: () => {
            dispatch(switchToOldInterfaceAction());
        },
        commonWalletClick: () => {
            dispatch(fireCommonWalletClick());
        },
        onRecommendationTooltipClose: () => {
            dispatch(hideRecommendationsTooltip());
        }
    };
};

export const HeaderContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(Header);
